import React from 'react';

export function ToolsTab({ formData, setFormData, onEditTool }) {
  const toolTypes = [
    { type: 'email', icon: '📧', name: 'Email' },
    { type: 'sms', icon: '📱', name: 'SMS' },
    { type: 'calendar', icon: '📅', name: 'Kalender' },
    { type: 'google_calendar', icon: '📆', name: 'Google Kal.' },
    { type: 'webhook', icon: '🔗', name: 'Webhook' }
  ];

  return (
    <div className="space-y-6">
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <p className="text-sm text-blue-800">
          <strong>Tools</strong> sind Aktionen, die der Agent während eines Gesprächs ausführen kann. Klicken Sie auf ein Tool, um es zu bearbeiten.
        </p>
      </div>

      {/* Tool List */}
      <div className="space-y-3">
        {(formData.tools || []).map((tool, index) => (
          <div key={index} onClick={() => onEditTool({ ...tool, index })} className="flex items-center justify-between p-4 bg-gray-50 rounded-lg border border-gray-200 cursor-pointer hover:border-blue-300 hover:bg-blue-50/30 transition-colors">
            <div className="flex items-center gap-4">
              <span className="text-2xl">
                {tool.tool_type === 'email' && '📧'}
                {tool.tool_type === 'sms' && '📱'}
                {tool.tool_type === 'calendar' && '📅'}
                {tool.tool_type === 'google_calendar' && '📆'}
                {tool.tool_type === 'webhook' && '🔗'}
              </span>
              <div>
                <p className="font-medium text-gray-800">{tool.name || tool.tool_type}</p>
                <p className="text-sm text-gray-500">
                  {tool.tool_type === 'email' && (tool.config?.smtp_host ? `SMTP: ${tool.config.smtp_host}` : 'Nicht konfiguriert')}
                  {tool.tool_type === 'sms' && (tool.config?.from_number ? `Von: ${tool.config.from_number}` : 'Nicht konfiguriert')}
                  {tool.tool_type === 'calendar' && (tool.config?.api_key ? `Cal.com: ${tool.config.username || 'konfiguriert'}` : 'Nicht konfiguriert')}
                  {tool.tool_type === 'webhook' && (tool.config?.url ? tool.config.url.substring(0, 40) + '...' : 'Nicht konfiguriert')}
                </p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <span className={`px-2 py-1 text-xs rounded-full ${tool.config?.smtp_host || tool.config?.account_sid || tool.config?.url || tool.config?.api_key ? 'bg-green-100 text-green-700' : 'bg-yellow-100 text-yellow-700'}`}>
                {tool.config?.smtp_host || tool.config?.account_sid || tool.config?.url || tool.config?.api_key ? '✓ Konfiguriert' : '⚠ Einrichten'}
              </span>
              <span className="text-gray-400">→</span>
            </div>
          </div>
        ))}
      </div>

      {/* Add Tool Buttons */}
      <div>
        <h4 className="font-medium text-gray-700 mb-3">Tool hinzufügen</h4>
        <div className="grid grid-cols-3 sm:grid-cols-5 gap-2 sm:gap-3">
          {toolTypes.map((toolType) => (
            <button key={toolType.type} onClick={() => onEditTool({ tool_type: toolType.type, name: toolType.name, enabled: true, config: {}, index: -1 })} className="flex flex-col items-center gap-1.5 sm:gap-2 p-3 sm:p-4 border-2 border-dashed border-gray-300 rounded-lg hover:border-blue-400 hover:bg-blue-50 transition-colors">
              <span className="text-2xl">{toolType.icon}</span>
              <span className="text-sm font-medium text-gray-700">{toolType.name}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
